import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "https://backre-miami.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

const p = (path) => `/${String(path || "").replace(/^\/+/, "")}`;

const getToken = () => localStorage.getItem("token") || "";

const auth = () => {
  const token = getToken();
  return token ? { headers: { token } } : {};
};

async function req(method, url, { params, data, signal } = {}) {
  const res = await API.request({
    method,
    url,
    params,
    data,
    signal,
    ...auth(),
  });

  return res.data;
}

const unwrapSeguimientos = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.seguimientos)) return data.seguimientos;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

const unwrapSeguimiento = (data) => {
  if (!data) return null;
  if (data?.seguimiento) return data.seguimiento;
  if (data?.data) return data.data;
  return data;
};

export async function getSeguimientosClientes({
  clienteCompra = "",
  venta = "",
  estado = "",
  q = "",
  activo = "true",
  alcanceReporte = "",
  page = 1,
  limit = 50,
  signal,
} = {}) {
  const params = {
    clienteCompra,
    venta,
    estado,
    q,
    activo,
    alcanceReporte,
    page,
    limit,
  };

  Object.keys(params).forEach((k) => {
    if (params[k] === "" || params[k] === null || params[k] === undefined) {
      delete params[k];
    }
  });

  const data = await req("GET", p("seguimientosclientes"), {
    params,
    signal,
  });

  const seguimientos = unwrapSeguimientos(data);

  return {
    seguimientos,
    total: Number(data?.total ?? seguimientos.length ?? 0),
    page: Number(data?.page ?? page),
    limit: Number(data?.limit ?? limit),
  };
}

export async function getResumenSeguimientosCliente({
  clienteCompra = "",
  venta = "",
  signal,
} = {}) {
  const params = {
    clienteCompra,
    venta,
  };

  Object.keys(params).forEach((k) => {
    if (!params[k]) delete params[k];
  });

  const data = await req("GET", p("seguimientosclientes/resumen"), {
    params,
    signal,
  });

  return data?.resumen || {
    total: 0,
    pendientes: 0,
    alta: 0,
    ultimo: null,
  };
}

export async function postSeguimientoCliente(payload, { signal } = {}) {
  return req("POST", p("seguimientosclientes"), {
    data: {
      clienteCompra: payload.clienteCompra,
      venta: payload.venta || null,
      texto: payload.texto,
      estado: payload.estado || "PENDIENTE",
      prioridad: payload.prioridad || "NORMAL",
    },
    signal,
  });
}

export async function putSeguimientoCliente(id, payload, { signal } = {}) {
  const data = await req("PUT", p(`seguimientosclientes/${id}`), {
    data: payload,
    signal,
  });

  return unwrapSeguimiento(data);
}

export async function resolverSeguimientoCliente(id, { signal } = {}) {
  const data = await req("PUT", p(`seguimientosclientes/${id}/resolver`), {
    signal,
  });

  return unwrapSeguimiento(data);
}

export async function deleteSeguimientoCliente(id, { signal } = {}) {
  return req("DELETE", p(`seguimientosclientes/${id}`), {
    signal,
  });
}